import React from 'react';
import {OrderType} from "../../../../services/Api/types";
import {ReactComponent as CarIco} from "../../../../../images/icons/car.svg";
import {ReactComponent as PickUpIco} from "../../../../..//images/icons/pick-up.svg";
import {ReactComponent as DineInIco} from "../../../../..//images/icons/dine-in.svg";
import {ReactComponent as RoomServiceIco} from "../../../../..//images/icons/room-service.svg";
import {useTranslation, withTranslation} from "react-i18next";
import {RootState} from "../../../../../reducers";
import {getAvailabilities, getMenus} from "../../../../services/Menu/reducer";
import {connect, DispatchProp} from "react-redux";
import AvailableHelper from "../../../../services/Menu/services/Availability/AvailableHelper";
import DateService from "../../../../services/Common/Date/DateService";
import {createKeyDownHandler} from "../../../../utils/keyDownHanlder";
import {getParsedSessionOrderType} from "../../../../utils/order";
import HoursHelper from "../../../../services/Menu/services/Availability/HoursHelper";
import {getStoreConfig} from "../../../../services/Store/reducer";
import {isTimeAllDay} from "../../../../services/Common/Date/DateHelper";
import StoreUtils from "../../../../services/Store/StoreUtils";

interface OwnProps {
    type: OrderType;
    checked: boolean;
    onChange: (type: OrderType, isOpen: boolean) => void;
    time: string | undefined;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

const CartChangeOrderDetailsTypeOptionModal = ({
                                                   type,
                                                   checked,
                                                   onChange,
                                                   availabilities,
                                                   menus,
                                                   time,
                                                   config,
                                               }: Props) => {
    const {t} = useTranslation();
    const finalType = getParsedSessionOrderType(type);
    const menuAvailabilities = AvailableHelper.getAvailabilities(availabilities, menus.map((menu: any) => menu[finalType.toLowerCase()] === true && menu.availability_id));
    const hours: {
        hour_from: string;
        hour_to: string;
    }[] = AvailableHelper.getHoursAvailable(menuAvailabilities, DateService.emptyOrNow(time)) || [];
    const isStoreOpen = HoursHelper.isOpen(config?.hours || [], DateService.emptyOrNow(time));
    const isOpenForCurrentType = menuAvailabilities.some((availability: any) => AvailableHelper.isAvailabile(availability, DateService.emptyOrNow(time)));
    const isTypeSupported = config && StoreUtils.getOrderTypes(config).includes(type);

    const getIcon = () => {
        switch (type) {
            case OrderType.DINE_IN:
                return <DineInIco/>;
            case OrderType.PICK_UP:
                return <PickUpIco/>
            case OrderType.DELIVERY:
                return <CarIco/>;
            case OrderType.ROOM_SERVICE:
                return <RoomServiceIco/>;
            default:
                return <></>;
        }
    }

    const drawOpenHours = () => {
        if (!isTypeSupported) {
            return <small className="text-danger">
                {t("common.word.not_available")}
            </small>
        }

        if (!isStoreOpen) {
            return <small className="text-danger">
                {t("enums.store_status.closed")}
            </small>
        }

        if (!isOpenForCurrentType) {
            return <small className="text-danger">
                {t("common.word.not_available")}
            </small>
        }

        const hoursTitle = hours.length === 1 && isTimeAllDay(hours[0].hour_from) && isTimeAllDay(hours[0].hour_to) ?
            t("modules.cart.field.whole_day.title") :
            hours.map(item => `${item.hour_from} - ${item.hour_to}`).join(", ");

        return (
            <small className="text-muted">
                {hoursTitle}
            </small>
        )
    }

    const handleOnLabelKeyDown = createKeyDownHandler<HTMLLabelElement>({
        keys: ["Enter", " "],
        preventDefault: false,
        action: () => onChange(type, isOpenForCurrentType && isStoreOpen)
    });

    return (
        <label tabIndex={0} aria-checked={checked} onKeyDown={handleOnLabelKeyDown}
               className={`btn btn-default btn-lg btn-check-full ${checked ? " active" : ""} ${!isTypeSupported && !checked ? "disabled" : ""}`}>
            {getIcon()}
            <span>
                <p className="mb-0">{t(`enums.order.type.${type}`)}</p>
                {drawOpenHours()}
            </span>
            <input className="btn-check1" type="radio" name="type" value={type} autoComplete="off" tabIndex={-1}
                   checked={checked}
                   onChange={(event) => onChange(event.target?.value as OrderType, isOpenForCurrentType && isStoreOpen)}/>
        </label>
    )
}

const mapStateToProps = (state: RootState) => ({
    menus: getMenus(state.menu),
    availabilities: getAvailabilities(state.menu),
    config: getStoreConfig(state.config),
});

const connector = connect(mapStateToProps);
export default withTranslation()(connector(CartChangeOrderDetailsTypeOptionModal));